import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { TeamMembersAuditInfo } from '@shared/models';
import { TeamMembersActions } from './team-members.actions';

export interface TeamMembersState {
  entities: TeamMembersAuditInfo;
  loading: boolean;
  error: string | null;
}

export const initialState: TeamMembersState = {
  entities: {},
  loading: false,
  error: null,
};

export const teamMembersFeature = createFeature({
  name: 'teamMembers',
  reducer: createReducer(
    initialState,
    on(TeamMembersActions.loadTeamMembers, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TeamMembersActions.loadTeamMembersSuccess, (state, { teamMembers }) => ({
      ...state,
      entities: {
        ...state.entities,
        ...teamMembers,
      },
      loading: false,
    })),
    on(TeamMembersActions.loadTeamMembersFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
  ),
  extraSelectors: ({ selectEntities }) => ({
    selectTeamMemberName: (id: string) =>
      createSelector(selectEntities, (entities: TeamMembersAuditInfo) => (id ? entities[id] || '' : '')),
  }),
});
